module.exports = __webpack_public_path__ + "static/img/h-08.b17e24e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h-08.jpg
// module id = kbVv
// module chunks = 1